import {
  DOWNPAYMENT_FAIL,
  POLLING_ORDER_STATUS,
  DOWNPAYMENT_SUCCESS,
  POLLING_ORDER_STATUS_SUCCESS,
  INITIATE_DOWNPAYMENT
} from "../../../constants";
import { setReservedTrip } from "../../../data/trips/actions";
import {
  createCustomerAndOrder,
  fetchOrderStatus,
  initiateDownPayment
} from "./api";

export function setCustomerInfo(values) {
  return { type: "SET_CUSTOMER_INFO", payload: values };
}

function paymentFailAction(error) {
  const payload = error.message
    ? error.message // E.g. Network Error
    : "We encountered an issue while processing the payment";

  return {
    type: DOWNPAYMENT_FAIL,
    payload
  };
}

// function setOrderId(orderId) {
//   return {
//     type: SET_ORDER_ID,
//     payload: orderId
//   };
// }

// export function submitCustomer({ history, requestPayload }) {
//   return dispatch => {
//     const url = `${BASE_URL}/customer`;
//     dispatch({ type: SUBMITING_CUSTOMER });

//     axios
//       .post(url, requestPayload)
//       .then(response => {
//         // console.log('response', response)
//         dispatch({ type: SUBMIT_CUSTOMER_SUCCESSFUL, payload: response.data });

//         // TODO push('users/:userId/orders/:orderId')
//         history.push("reservations");
//       })
//       .catch(error => {
//         dispatch({
//           type: SUBMIT_CUSTOMER_REJECTED,
//           payload: error.response.data
//         });
//       });
//   };
// }

/**
 * This submits a customer's payment to our servers. We get an order ID in return.
 * Due to the 30 second AWS API Gate limitation, we risk timing out during Priceline's; hence,
 * we use a polling architecture. We periodically poll the server to see the status of the
 * order using the returned ID
 */
export function submitPaymentAndPoll({ history, requestPayload, state }) {
  return async (dispatch, getState) => {
    dispatch({ type: INITIATE_DOWNPAYMENT });
    // dispatch({ type: CREATE_ORDER_AND_CUSTOMER });

    try {
      const {
        data: { orderId, keys }
      } = await createCustomerAndOrder(requestPayload);
      // dispatch({ type: CREATE_ORDER_AND_CUSTOMER_SUCCESS });

      // Start payment workflow in server
      initiateDownPayment(keys);

      // OrderId has to be set on reserverdTrip, so when we navigate to /reservations upon successful booking, we have it displayed!
      // Also, we need it to fetch "Airline Contact" and "Important Information" in /reservations.
      const reservedTrip = { ...getState().trips.reservedTrip };
      reservedTrip.orderId = orderId.createdAt;
      dispatch(setReservedTrip(reservedTrip));

      const orderStatus = await poll(
        () => fetchOrderStatus(orderId),
        1000 * 120,
        5000,
        dispatch
      );
      // Polling done!
      dispatch({ type: DOWNPAYMENT_SUCCESS, payload: orderStatus });
      history.push("reservations");

      // dispatch({type: POLLING_S});
    } catch (error) {
      // TODO Log error.message to server.
      const isApiError = error && error.response;
      if (isApiError) {
        dispatch(paymentFailAction(error.response.data));
      } else {
        dispatch(paymentFailAction(error));
      }
    }
  };
}

// POLLING
// We need to get the status of the Priceline payment job from the backend periodically.
// When it is complete, we alert app (removing spinners, going to next page etc.)

// The polling function
// export default function poll(orderId, timeout, interval) {
export default function poll(fn, timeout, interval, dispatch) {
  const endTime = Number(new Date()) + (timeout || 2000);
  interval = interval || 100;

  const checkCondition = async resolve => {
    dispatch({ type: POLLING_ORDER_STATUS });
    const fetchOrderStatusPromise = fn(); // New api call per fn call

    try {
      const {
        data: { orderStatus }
      } = await fetchOrderStatusPromise;
      dispatch({ type: POLLING_ORDER_STATUS_SUCCESS, payload: orderStatus });
      // console.log("order status in poll recursion...", orderStatus);
      if (orderStatus === "Ok" || orderStatus === "pricelinePaymentComplete") {
        resolve(orderStatus);
      } else if (orderStatus.includes("error")) {
        // reject(new Error(orderStatus));
        throw new Error(orderStatus); // For Async/Await, using passed "reject" above doesn't work. We throw.
      }
      // If the condition isn't met but the timeout hasn't elapsed, go again
      else if (Number(new Date()) < endTime) {
        setTimeout(checkCondition, interval, resolve);
      }
      // Didn't match and too much time, reject!
      else {
        // reject(new Error("Payment request timed out."));
        throw new Error("Payment request timed out.");
      }
    } catch (error) {
      // TODO: Log error.message to server
      dispatch(paymentFailAction(error));
    }
  };

  return new Promise(checkCondition);
}



// WEBPACK FOOTER //
// ./src/scenes/ReviewOrder/CustomerInfoForm/actions.js